// © Microsoft Corporation. All rights reserved.

import { TelemetryActionType, TelemetryBehaviorType, TelemetryContentType, TelemetryObjectBase } from "@msnews/telemetry-contracts";

export interface PublisherSubscribeFollowButtonTelemetryObjects {
    publisherSubscribeFollowButton: TelemetryObjectBase;
    publisherSubscribeFollowingButton: TelemetryObjectBase,
    publisherSubscribeSubscribedButton: TelemetryObjectBase;
    viewProfileLink: TelemetryObjectBase;
}

export const publisherSubscribeFollowButtonTelemetryContracts = {
    publisherSubscribeFollowButton: {
        name: "FollowButton",
        behavior: TelemetryBehaviorType.Undefined,
        action: TelemetryActionType.Click,
        content: {
            headline: "FollowButton",
            type: TelemetryContentType.Article
        }
    },
    publisherSubscribeFollowingButton: {
        name: "FollowingButton",
        behavior: TelemetryBehaviorType.Undefined,
        action: TelemetryActionType.Click,
        content: {
            headline: "FollowingButton",
            type: TelemetryContentType.Article
        }
    },
    publisherSubscribeSubscribedButton: {
        name: "Subscribed",
        behavior: TelemetryBehaviorType.Undefined,
        action: TelemetryActionType.Click,
        content: {
            headline: "Subscribed",
            type: TelemetryContentType.Article
        }
    },
    viewProfileLink: {
        name: "ViewProfile",
        behavior: TelemetryBehaviorType.Navigate,
        action: TelemetryActionType.Click,
        content: {
            headline: "ViewProfile",
            type: TelemetryContentType.Article
        }
    }
};
